import { Store } from 'pullstate';
import { PuzzleStoreBase, PuzzleStoreBaseDefaults } from '../../../utils/types';

export type RubigramStoreType = PuzzleStoreBase & {
  // This is whichever one has just been manipulated, to control
  // raising its z-index above the others for animation purposes.
  activeSubgrid: number;
  // This is how rotated the entire puzzle is, rather than any individual subgrid.
  degreesRotated: number;
  subgrids: {
    // This gets updated as the player flips and rotates the grid
    content: string[][];
    // This doesn't get updated ever; it's used to populate the visualization of the grids.
    // If we updated the data populating the grid AND flipped the grid visually,
    // then from the player's perspective it would result in each flip or rotation
    // happening twice.
    displayContent: string[][];
    // What should be in this corner if it's solved
    solvedContent: string[][];
    flippedHorizontally: boolean;
    flippedVertically: boolean;
    degreesRotated: number;
    isInFlippingAnimation: boolean;
  }[];
};

export const RubigramStore = new Store<RubigramStoreType>({
  ...PuzzleStoreBaseDefaults,
  activeSubgrid: 0,
  degreesRotated: 0,
  subgrids: Array(4).fill({
    content: [],
    displayContent: [],
    solvedContent: [],
    flippedHorizontally: false,
    flippedVertically: false,
    degreesRotated: 0,
    isInFlippingAnimation: false,
  }),
});